import React from "react";

/** One titled block of a long settings form, ruled off from the block above. */
export default function SettingsSection({ title, description, children }) {
  return (
    <section className="tw-flex tw-flex-col tw-gap-4 tw-border-0 tw-border-t tw-border-solid tw-border-line tw-pt-5 first:tw-border-t-0 first:tw-pt-0">
      <div>
        <h4 className="tw-m-0 tw-text-sm tw-font-semibold tw-text-content">{title}</h4>
        {description && <p className="tw-m-0 tw-mt-0.5 tw-text-xs tw-text-content-muted">{description}</p>}
      </div>
      {children}
    </section>
  );
}
